module.exports = __webpack_public_path__ + "assets/img/DS-room3 (8).a37d8a42.jpg";